import React, { useState } from "react";
import { clsx } from "clsx";
import {
    Plus as AddIcon,
    LogOut as LogoutIcon,
    Send as SendIcon,
    RefreshCw as CachedIcon,
    ChevronDown
} from "lucide-react";

// const options = ["React", "Vue", "Angular", "Svelte", "Next.js", "Nuxt.js"];

// export function Autocomplet2({ placeholder = "Selecione..." }) {
//   const [selected, setSelected] = useState(null);
//   const [query, setQuery] = useState("");

//   const filteredOptions =
//     query === ""
//       ? options
//       : options.filter((option) =>
//           option.toLowerCase().includes(query.toLowerCase())
//         );

//   return (
//     <Combobox value={selected} onChange={setSelected}>
//       <div className="relative w-64">
//         <Combobox.Input
//           className="w-full p-2 border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           onChange={(event) => setQuery(event.target.value)}
//           placeholder={placeholder}
//         />
//         <Combobox.Button className="absolute inset-y-0 right-2 flex items-center">
//           <ChevronDown className="w-5 h-5 text-gray-600 dark:text-gray-300" />
//         </Combobox.Button>
//         <Combobox.Options className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-60 overflow-auto">
//           {filteredOptions.length === 0 ? (
//             <div className="p-2 text-gray-500 dark:text-gray-400">Nenhum resultado</div>
//           ) : (
//             filteredOptions.map((option) => (
//               <Combobox.Option
//                 key={option}
//                 value={option}
//                 className={({ active }) =>
//                   `p-2 cursor-pointer flex items-center gap-2 ${
//                     active
//                       ? "bg-blue-500 text-white"
//                       : "text-gray-900 dark:text-white"
//                   }`
//                 }
//               >
//                 {({ selected }) => (
//                   <>
//                     {selected && <Check className="w-4 h-4" />}
//                     {option}
//                   </>
//                 )}
//               </Combobox.Option>
//             ))
//           )}
//         </Combobox.Options>
//       </div>
//     </Combobox>
//   );
// }

export const Button = ({ children, className, ...props }) => (
    <button
        className={clsx(
            "px-4 py-2 rounded-lg font-medium transition-all",
            "bg-blue-500 hover:bg-blue-600 text-white",
            "dark:bg-blue-700 dark:hover:bg-blue-800",
            className
        )}
        {...props}
    >
        {children}
    </button>
);

export const Card = ({ children, className }) => (
    <div
        className={clsx(
            "p-4 rounded-lg shadow-md bg-white dark:bg-gray-800",
            className
        )}
    >
        {children}
    </div>
);

export const CardContent = ({ children, className }) => (
    <div className={clsx("p-2", className)}>{children}</div>
);

export const Checkbox = ({ label, ...props }) => (
    <label className="flex items-center gap-2 cursor-pointer">
        <input
            type="checkbox"
            className="w-5 h-5 text-blue-600 dark:text-blue-400"
            {...props}
        />
        {label}
    </label>
);

export const FormControl = ({ children, className }) => (
    <div className={clsx("flex flex-col gap-2", className)}>{children}</div>
);

export const FormControlLabel = ({ label, children }) => (
    <div className="flex items-center gap-2">
        {children}
        <span>{label}</span>
    </div>
);

export const InputLabel = ({ children, className }) => (
    <label className={clsx("font-medium", className)}>{children}</label>
);

export const MenuItem = ({ children, ...props }) => (
    <option {...props}>{children}</option>
);

export const Select = ({ options, ...props }) => (
    <select
        className="px-3 py-2 border rounded-lg bg-white dark:bg-gray-700 dark:text-white"
        {...props}
    >
        {options.map((opt, idx) => (
            <option key={idx} value={opt.value}>
                {opt.label}
            </option>
        ))}
    </select>
);

export const Slider = ({ ...props }) => (
    <input
        type="range"
        className="w-full cursor-pointer"
        {...props}
    />
);

export const Tab = ({ label, active, onClick }) => (
    <button
        onClick={onClick}
        className={clsx(
            "px-4 py-2 rounded-t-lg border-b-2",
            active
                ? "border-blue-500 text-blue-500 dark:border-blue-400 dark:text-blue-400"
                : "border-transparent text-gray-500 dark:text-gray-400"
        )}
    >
        {label}
    </button>
);

export const Tabs = ({ tabs, activeTab, onChange }) => {
    return <div className="flex border-b dark:border-gray-600">
        {tabs.map((tab, idx) => (
            <Tab
                key={idx}
                label={tab.label}
                active={activeTab === idx}
                onClick={() => onChange(idx)}
            />
        ))}
    </div>
};

export const TextField = ({ label, className, ...props }) => (
    <div className="flex flex-col gap-1">
        {label && <InputLabel>{label}</InputLabel>}
        <input
            className={clsx(
                "px-3 py-2 border rounded-lg",
                "bg-white dark:bg-gray-700 dark:text-white",
                className
            )}
            {...props}
        />
    </div>
);

export const Typography = ({ variant = "p", children, className }) => {
    const Component = variant;
    return (
        <Component
            className={clsx(
                "text-gray-900 dark:text-gray-100",
                variant === "h1" && "text-3xl font-bold",
                variant === "h2" && "text-2xl font-semibold",
                variant === "p" && "text-base",
                className
            )}
        >
            {children}
        </Component>
    );
};

export { AddIcon, LogoutIcon, SendIcon, CachedIcon };
